import React, { useState, useEffect } from "react";
import {
  getActivitys,
  downloadExcelReport,
} from "../services/activityListService";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "bootstrap";
import "./ActivityList.css";
import { showErrorAlert, showWarningAlert } from "../services/alertService";

const ActivityList = () => {
  const [activities, setActivities] = useState([]);
  const [date, setDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;

  const fetchActivities = async (selectedDate, page) => {
    try {
      const data = await getActivitys(selectedDate, page, itemsPerPage);
      setActivities(data.actividades);
      setPageCount(data.totalPages);
      setCurrentPage(data.currentPage);
    } catch (error) {
      showErrorAlert("Failed to fetch activities");
      console.error("Failed to fetch activities", error);
    }
  };

  useEffect(() => {
    fetchActivities(date, currentPage);
  }, [date, currentPage]);

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
  }, []);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0); // Reset to first page on date change
    fetchActivities(date, 0);
  };

  const handleReset = () => {
    setDate("");
    setCurrentPage(0);
  };

  const handleDownload = async () => {
    if (!date) {
        showWarningAlert("Selecciona una fecha para descargar el Reporte.");
      return;
    }
    setLoading(true);
    try {
      await downloadExcelReport(date);
    } catch (error) {
      showErrorAlert("Failed to download the report");
      console.error("Failed to download the report", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activity-list container mt-4">
      <form className="d-flex mb-4" onSubmit={handleSubmit}>
        <input
          type="date"
          className="form-control me-2"
          id="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <button type="submit" className="btn btn-primary me-2">
          Filter
        </button>
        <button 
          type="button" 
          onClick={handleReset} 
          className="btn btn-secondary me-2">
          Limpiar
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={handleDownload}
          disabled={loading || activities.length === 0}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Descargar informe en Excel"
        >
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <FontAwesomeIcon icon={faDownload} />
          )}
          <span className="ms-2">
            {loading ? "Downloading..." : "Download Excel"}
          </span>
        </button>
      </form>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Fecha Inicio</th>
            <th scope="col">Fecha Fin</th>
            <th scope="col">Colaborador</th>
            <th scope="col">Maquinaria</th>
            <th scope="col">Proceso</th>
            <th scope="col">Material</th>
          </tr>
        </thead>
        <tbody>
          {activities.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No hay datos para mostrar
              </td>
            </tr>
          ) : (
            activities.map((activity) => (
              <tr key={activity.id}>
                <td>{activity.id}</td>
                <td>
                  {new Date(activity.fechaHoraInicio).toLocaleDateString() +
                    " " +
                    new Date(activity.fechaHoraInicio).toLocaleTimeString()}
                </td>
                <td>
                  { activity.fechaHoraFin ? new Date(activity.fechaHoraFin).toLocaleDateString() +
                    " " +
                    new Date(activity.fechaHoraFin).toLocaleTimeString() : "En curso"}
                </td>
                <td>
                  {activity.colaborador.apellido +
                    ", " +
                    activity.colaborador.nombre}
                </td>
                <td>{activity.relacion.Maquinarium.name}</td>
                <td>{activity.relacion.Proceso.name}</td>
                <td>{activity.relacion.Material.name}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
};

export default ActivityList;
